import Vue from 'vue'

export function showSuccessMessage(message) {
  if (message) {
    Vue.notify({
      group: 'default',
      title: message,
      type: 'success',
      duration: 3000
    })
  }
}

export function showErrorMessage(message = 'Something went wrong') {
  Vue.notify({
    group: 'default',
    title: message,
    type: 'error',
    duration: 5000
  })
}

export function showWarningMessage(message) {
  if (message) {
    Vue.notify({
      group: 'default',
      title: message,
      type: 'warn',
      duration: 5000
    })
  }
}

export function showInfoMessage(message) {
  if (message) {
    Vue.notify({
      group: 'default',
      title: message,
      type: 'info',
      duration: 5000
    })
  }
}